// setAssetPoster.js
'use strict';
import { MERGE_ASSET_DATA, REMOVE_ASSET_DATA } from '../ActionTypes.js';
import { ASSET_FILE_SIZE_MAX } from '../RemoteConfigKeys.js';

import pushToastr from '../action/pushToastr.js';

import getAssetData from '../selector/getAssetData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import { ArtifactType } from '../resource/assetConstants.js';
import { Status as UploadStatus } from '../resource/uploadConstants.js';
import formatBytes from '../resource/formatBytes.js';
import uploadJobReferences from '../resource/uploadJobReferences.js';

/**
 * Set asset poster
 * @kind action
 * @param {string} {assetId} - asset id.
 * @param {File} {file} - file object. if file is empty means clear current poster file.
 * @return {Promise} Action promise.
 */
const setAssetPoster =
  ({ assetId, file } = {}) =>
  async (dispatch, getState) => {
    const currentAssetPosterObjectUrl = getAssetData(
      getState(),
      [assetId, ArtifactType.THUMBNAIL],
      'objectUrl'
    );
    if (!file) {
      if (currentAssetPosterObjectUrl) {
        URL.revokeObjectURL(currentAssetPosterObjectUrl);
      }
      uploadJobReferences.set(
        `${assetId}:${ArtifactType.THUMBNAIL}:file`,
        undefined
      );
      return dispatch({
        type: REMOVE_ASSET_DATA,
        payload: {
          selectPath: [assetId, ArtifactType.THUMBNAIL],
        },
      });
    }
    const maxFileSize = getRemoteConfigData(getState(), ASSET_FILE_SIZE_MAX);
    const isValid = file.size <= maxFileSize;
    if (!isValid) {
      return dispatch(
        pushToastr({
          textKey: 'upload_file_error_hint',
          textKeyOption: {
            size: formatBytes({
              bytes: maxFileSize,
            }),
          },
          color: 'error',
        })
      );
    }
    if (currentAssetPosterObjectUrl) {
      URL.revokeObjectURL(currentAssetPosterObjectUrl);
    }
    uploadJobReferences.set(`${assetId}:${ArtifactType.THUMBNAIL}:file`, file);
    return dispatch({
      type: MERGE_ASSET_DATA,
      payload: {
        selectPath: [assetId, ArtifactType.THUMBNAIL],
        data: {
          objectUrl: URL.createObjectURL(file),
          filename: file.name,
          status: UploadStatus.PENDING,
          progress: 0,
        },
      },
    });
  };

export default setAssetPoster;
